/* globals Vitafy */

import { updateResults, updateStatus } from '!/actions/creators';
import compose from 'lodash/flowRight';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import qs from 'querystring';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

const actions = {
  updateResults,
  updateStatus
};
class SearchProvider extends Component {
  static contextTypes = {
    isDebugMode: PropTypes.bool
  };

  render() {
    return <Fragment>{this.props.children}</Fragment>;
  }

  async componentWillReceiveProps(nextProps) {
    const keys = ['values', 'applied', 'page', 'q', 'categoryPath'];

    if (isEqual(pick(nextProps, keys), pick(this.props, keys))) {
      return;
    }

    const { page: p, applied, values, q, categoryPath, storeCode: code, categoryId } = nextProps;

    // remove empty filter entries
    const filters = Object.fromEntries(
      Object.entries(values)
        .filter(([_, value]) => {
          if (Array.isArray(value)) {
            return value.length > 0;
          } else {
            return value !== '' && value !== null && value !== undefined;
          }
        })
    );

    let params = { q, p, code, filters };

    if (!params.q) {
      delete params.q;
    }

    if (params.p === 1) {
      delete params.p;
    }

    this.performSearch(params, { p, applied, values, q, categoryPath, categoryId });
  }

  /**
   * Perform search
   * @param {Object} params Request parameters
   */
  performSearch(params, nextProps) {
    const { updateStatus, updateResults, router } = this.props;
    const { p, q, filters: filtersAndSort } = params;
    const { categoryId } = nextProps;
    const { sort, ...filters } = filtersAndSort;
    const defaultSort = 'relevance_desc';

    // API changed
    const sortNormalized = sort === 'score_desc' ? 'relevance_desc' : sort;

    if (this.timer) {
      clearTimeout(this.timer);
    }

    const backendQueryString = qs.stringify(params);
    delete params.categoryPath;
    const storeCode = params.code;
    delete params.code;
    delete params.filters;

    const frontendQueryString = qs.stringify({ ...params, sort: sortNormalized ?? defaultSort, ...(Object.keys(filters).length > 0 && { filters: JSON.stringify(filters) }) });
    const newUrl =
      window.location.pathname + (frontendQueryString ? `?${frontendQueryString}` : '') + window.location.hash; 

    this.timer = setTimeout(async () => {
      router.push(
        {
          pathname: '/search',
          query: {
            data: JSON.stringify(nextProps),
            isDebugMode: this.context.isDebugMode ? 1 : 0,
            // isStandalone: 1
          }
        },
        newUrl,
        { scroll: false }
      );

      updateStatus('loading');
      try {
        const serverQueryParams = qs.stringify({ page: p ?? 1, storeCode, sort: sortNormalized ?? defaultSort, filters: JSON.stringify(filters), resultsPerPage: 48 });
        var response = null;
         if (categoryId) {
          response = await fetch(`${process.env.NEXT_PUBLIC_SEARCH_API_URL || 'https://search.vitafy.de'}/v1/search/productsByCategory?categoryId=${categoryId}&${serverQueryParams}`);
        } else {
          response = await fetch(`${process.env.NEXT_PUBLIC_SEARCH_API_URL || 'https://search.vitafy.de'}/v1/search/products?terms=${q||''}&${serverQueryParams}`);
        }
        const result = await response.json();
        updateResults(result.initialStoreState);
      } catch (e) {
        console.error(e);
      } finally {
        updateStatus('pending');
      }
    }, 250);
  }
}

function mapStateToProps({ categoryId, values, page, applied, q, categoryPath, storeCode }) {
  return {
    page,
    values,
    applied,
    q,
    storeCode,
    categoryPath,
    categoryId
  };
}

export default compose(
  connect(
    mapStateToProps,
    actions
  ),
  withRouter
)(SearchProvider);
